"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterFormGtm = exports.PossibleUserTypeEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const ReactDOM = require("react-dom");
const app_1 = require("app");
const formik_1 = require("formik");
const react_google_recaptcha_1 = require("react-google-recaptcha");
const dhsInstallerHelpers_1 = require("../../DhsInstaller/helpers/dhsInstallerHelpers");
const FormikConfig_1 = require("Views/Partials/Components/FormikFields/FormikConfig");
const NewsletterGtmFormConfig_1 = require("../NewsletterGtmFormConfig");
const NewsletterBanner_1 = require("./NewsletterBanner");
var PossibleUserTypeEnum;
(function (PossibleUserTypeEnum) {
    PossibleUserTypeEnum[PossibleUserTypeEnum["Business"] = 0] = "Business";
    PossibleUserTypeEnum[PossibleUserTypeEnum["Personal"] = 1] = "Personal";
})(PossibleUserTypeEnum || (exports.PossibleUserTypeEnum = PossibleUserTypeEnum = {}));
const NewsletterFormGtm = props => {
    const [formState, setFormState] = React.useState(null);
    const recaptchaRef = React.createRef();
    const RecaptchaComponent = react_google_recaptcha_1.default;
    const gtmData = (() => {
        const { items, control } = props;
        const { titleText } = items.specificFields;
        return {
            control: control,
            label: items.submitLabel,
            title: titleText,
        };
    })();
    const { apiUrl, additionalFormData, reCaptchaSiteKey, items: { specificFields }, renderMessage, renderSpinner, pageId, bypassRecaptchaKey, } = props;
    const recaptchaBypass = (0, FormikConfig_1.recaptchaKeyGuard)(bypassRecaptchaKey);
    const initialFormState = (0, dhsInstallerHelpers_1.updateInitialFormValues)(props, NewsletterGtmFormConfig_1.newFormInitialFormState);
    // Reset Recaptcha manually
    (0, app_1.useRecaptchaReset)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "newsletter-form-main w-full", children: [(0, jsx_runtime_1.jsx)(NewsletterBanner_1.default, Object.assign({}, additionalFormData)), (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: initialFormState, validationSchema: (0, NewsletterGtmFormConfig_1.getNewFormValidationSchema)(), enableReinitialize: true, validateOnBlur: false, validateOnMount: true, onSubmit: (values) => {
                    recaptchaBypass
                        ? (0, FormikConfig_1.submitForm)(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, '', pageId)
                        : (0, dhsInstallerHelpers_1.performReCaptchaCheck)(recaptchaRef, renderMessage, specificFields);
                    setFormState((prevState) => (Object.assign(Object.assign({}, prevState), values)));
                }, children: ({ values, errors, touched, isSubmitting, isValidating }) => {
                    (0, dhsInstallerHelpers_1.handleGtmValidationError)(isValidating, isSubmitting, gtmData, errors, values);
                    return ((0, jsx_runtime_1.jsx)(formik_1.Form, { children: (0, FormikConfig_1.renderFormItems)(props, errors, touched, values, gtmData, NewsletterGtmFormConfig_1.newTypeFormConfig) }));
                } }), !recaptchaBypass &&
                ReactDOM.createPortal((0, jsx_runtime_1.jsx)(RecaptchaComponent, { className: "newsletter-recaptcha recaptcha-mounted", ref: recaptchaRef, size: "invisible", sitekey: reCaptchaSiteKey, onChange: recaptchaToken => (0, FormikConfig_1.submitForm)(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, recaptchaToken, pageId), onErrored: () => (0, dhsInstallerHelpers_1.handleError)(gtmData, renderMessage, specificFields) }), document.body)] }));
};
exports.NewsletterFormGtm = NewsletterFormGtm;
